import { useMutation } from "@tanstack/react-query";
import {
  type AuthenticationUrl,
  type BankEnvironment,
  getBankingAuthAuthenticatePisp,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

type Props = {
  onSuccess: (props: AuthenticationUrl) => void;
};

type MutationPayloadType = {
  environment: BankEnvironment;
};

export const useBankingPispAuthQuery = ({ onSuccess }: Props) => {
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ environment }: MutationPayloadType) =>
        getBankingAuthAuthenticatePisp(environment),
    ),
    onSuccess,
    // Without feedback a failed authorization looks like the button did nothing.
    onError: () => toast.error(t(Resources.Hooks.BankingAuth.Error)),
  });
};
